import { ModelTraining } from '@mui/icons-material'

import Routes from '@tabeeb/routes'
import { useSelector } from '@tabeeb/store'
import { NavbarItem } from '@collaborate-health/uikit'
import {
  getIsAIExpressionsEnabled,
  getIsChatBotsFeatureEnabled,
  getShowMenuAI,
} from '@tabeeb/modules/appConfigState/selectors'
import { getIsModelTrainingEnabled } from '@tabeeb/modules/artificialIntelligence/selectors'
import { hasTenantPermission } from '@tabeeb/modules/permissions/selectors'
import { TenantPermission } from '@tabeeb/enums'

const AITab: React.FC = () => {
  const isAiExpressionsEnabled = useSelector(getIsAIExpressionsEnabled)
  const isModelTrainingEnabled = useSelector(getIsModelTrainingEnabled)
  const isChatBotsFeatureEnabled = useSelector(getIsChatBotsFeatureEnabled)

  const display = useSelector(
    (state) => getShowMenuAI(state) && hasTenantPermission(state, TenantPermission.AISettings)
  )
  if (!display) {
    return null
  }

  return (
    <NavbarItem name='AI' href={Routes.aiModels} icon={<ModelTraining />}>
      <NavbarItem key='Models' subitem href={Routes.aiModels} name='Models' />
      <NavbarItem key='CV classes' subitem href={Routes.aiObjects} name='CV classes' />
      {isModelTrainingEnabled && (
        <NavbarItem key='Model training' subitem href={Routes.aiProjects} name='Model training' />
      )}
      {isAiExpressionsEnabled && (
        <NavbarItem key='AI expressions' subitem href={Routes.aiExpressions} name='AI expressions' />
      )}
      {isChatBotsFeatureEnabled && <NavbarItem key='Assistants' subitem href={Routes.assistants} name='Assistants' />}
    </NavbarItem>
  )
}

export default AITab

